export const queryKeys = {
  activeArticleId: 'activeArticleId',
  activeCalendarDate: 'activeDate',
  activeCalendarTab: 'activeTab',
  activeDate: 'activeDate',
  activeDrawer: 'activeDrawer',
  activeDrawerTab: 'activeDrawerTab',
  activeHistorySidebarCategory: 'activeHistorySidebarCategory',
  drawerExpanded: 'drawerExpanded',
  earningsId: 'earningsId',
  epsFilter: 'epsFilter',
  epsValue: 'epsValue',
  episodeDates: 'episodeDates',
  activeInsight: 'activeInsight',
  activeInsightHorizon: 'activeInsightHorizon',
  activeInsightId: 'activeInsightId',
  activeModal: 'activeModal',
  activePill: 'activePill',
  activeSubTab: 'activeSubTab',
  activeTab: 'activeTab',
  assetOverview: 'assetOverview',
  assetOverviewAsset: 'asset',
  assetOverviewSectionId: 'sectionId',
  assetOverviewSubTab: 'subTab',
  assetOverviewTab: 'tab',
  billingCycle: 'billingCycle',
  citationGroupId: 'CITATION_GROUP_ID',
  citationId: 'citationId',
  codelist: 'codelist',
  conversationId: 'conversationId',
  centralNode: 'node',
  scrollTo: 'scrollTo',
  competitorTag: 'competitorTag',
  documentId: 'DOCUMENT_ID',
  emailReset: 'emailToReset',
  entityTag: 'entityTag',
  geoSubTab: 'geoSubTab',
  history: 'history',
  horizon: 'horizon',
  insight: 'insight',
  insightId: 'insightId',
  insightName: 'insightName',
  insightTitle: 'insightTitle',
  limited: 'limited',
  mode: 'mode',
  product: 'product',
  promoCode: 'promo_code',
  reason: 'reason',
  redirect: 'redirectTo',
  searchNews: 'search',
  snakeType: 'snakeType',
  source: 'source',
  themeId: 'themeId',
  themeHorizon: 'themeHorizon',
  countryCode: 'countryCode',
  regionName: 'regionName',
  tier: 'tier',
  type: 'type',
  view: 'view',
  watchlistId: 'watchlistId',
  widget: 'widget',
  filters: 'filters',
  newsFilters: 'newsFilters',
  newsMostRead: 'newsMostRead',
  nodeType: 'nodeType',
  utmCampaign: 'utm_campaign',
  utmSource: 'utm_source',
  activeFinancialsStatement: 'financials_statement',
  activeFinancialsTimeframe: 'financials_timeframe',
  insightRelation: 'insightRelation',
  economicCalendarFrom: 'ec_from',
  economicCalendarTo: 'ec_to',
  economicCalendarCountries: 'ec_countries',
  economicCalendarCategories: 'ec_categories',
  economicCalendarEntityTag: 'ec_entity',
  industryThemeId: 'industryThemeId',
} as const;

export const DRAWER_PARAM_KEYS = [
  queryKeys.activeDrawer,
  queryKeys.type,
  queryKeys.entityTag,
  queryKeys.themeId,
  queryKeys.themeHorizon,
  queryKeys.insightId,
  queryKeys.activeDrawerTab,
  queryKeys.earningsId,
  queryKeys.activeInsight,
  queryKeys.source,
  queryKeys.insightRelation,
  queryKeys.utmSource,
  queryKeys.utmCampaign,
  queryKeys.economicCalendarFrom,
  queryKeys.economicCalendarTo,
  queryKeys.economicCalendarCountries,
  queryKeys.economicCalendarCategories,
  queryKeys.economicCalendarEntityTag,
  queryKeys.activeArticleId,
  queryKeys.industryThemeId,
] as const;

export const EMAIL_TRACKING_PARAM_KEYS = [
  queryKeys.utmSource,
  queryKeys.utmCampaign,
] as const;

export const getCleanDrawerParams = () =>
  Object.fromEntries(DRAWER_PARAM_KEYS.map(k => [k, undefined]));

export const queryValues = {
  articleDrawer: 'article',
  documentModal: 'document',
  deepResearchMode: 'research',
  rankingMethodologyDrawer: 'ranking_methodology',
  geographicExposureDrawer: 'geographic_exposure',
  brandAndProductDrawer: 'brand_and_product',
  competitorsDrawer: 'competitors',
  catalystInsightsDrawer: 'catalyst',
  marketCatalystDrawer: 'market_catalyst',
  marketInsightDrawer: 'market_insight',
  monthlySentimentDrawer: 'monthly_sentiment',
  earningsDrawer: 'earnings',
  themeDrawer: 'theme',
  companyToThemeDrawer: 'company_to_theme',
  earningsInsightDrawer: 'earnings_insight',
  economicCalendarDrawer: 'economic-calendar',
  insightsDrawer: 'insights',
  insightsFullDrawer: 'insights_full',
  followingDescriptionDrawer: 'following_description',
  manageFollowingDrawer: 'following_drawer',
  whatsNewSettingsDrawer: 'whats_new_settings',
  parentCategoryDrawer: 'parent_category',
  scheduleQueryDrawer: 'scheduleQueryDrawer',
  promptLibrary: 'promptLibrary',
  focus: 'focus',
  explore: 'explore',
  industryThemeDrawer: 'industry_theme',
} as const;
